import React from 'react'
import { Outlet } from 'react-router-dom'

const Reports = () => {
    return (
        <div>
            <Outlet />
        </div>
    )
}

export default Reports
